module.exports = __webpack_public_path__ + "img/emoji-cash@3x.aac3944.png";